import logo from '../../assets/svg/logo-election2026.svg'

const nav = [
  {
    title: 'Governor',
    href: 'governor',
    icon: 'mn-seal',
  },
  {
    title: 'U.S. House',
    href: 'us/house',
    icon: 'mn-us-house-dist',
  },
  {
    title: 'U.S. Senate',
    href: 'us/senate',
    icon: 'mn',
  },
  {
    title: 'Statewide',
    href: 'statewide',
    icon: 'mn',
  },
  {
    title: 'Minnesota Senate',
    href: 'mn/senate',
    icon: 'mn-senate',
  },
  {
    title: 'Minnesota House',
    href: 'mn/house',
    icon: 'mn-house',
  },
  {
    title: 'Local Races by County',
    href: 'county',
    icon: 'mn-counties',
  },
  {
    title: 'Live Coverage',
    href: 'https://www.mprnews.org', // TODO: 2026 live coverage URL
    icon: 'live',
  },
]

const overview = [
  {
    title: 'Statewide Races',
    href: 'governor',
    buttonText: 'More Results',
    label: 'governor',
    type: 'Race',
  },
  {
    title: 'U.S. Senate in Minnesota',
    label: 'usSenate',
    href: 'us/senate',
    buttonText: 'Details',
    type: 'Race',
  },
  {
    title: 'U.S. House in Minnesota',
    label: 'usHouse',
    href: 'us/house',
    buttonText: 'Details',
    type: 'Race',
  },
  {
    label: 'attorneyGeneral',
    type: 'Race',
  },
  {
    label: 'secretaryOfState',
    type: 'Race',
  },
  {
    label: 'auditor',
    type: 'Race',
  },
  {
    title: 'Statewide Races',
    href: 'statewide',
    buttonText: 'See All Races',
    bodyText:
      'Results for the attorney general, secretary of state and auditor.',
  },
  {
    title: 'Local Races',
    href: 'county',
    buttonText: 'View Counties',
    bodyText:
      'Results in mayoral races, school boards, ballot measures and more.',
  },
]

const electionConfig = {
  ap: false,
  isPrimary: true,
  slug: 'electionConfig2026primary',
  date: '2026-08-11',
  nav: nav,
  year: '2026',
  overview: overview,
  logo: logo,
  previousElections: {
    governor: '2022-11-08', // TODO confirm
    legislature: '2024-11-05', // TODO confirm
  },
}

export default electionConfig
